import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import customtheme from "../../../themes";
import { Button, Checkbox, Container, FormControlLabel, Grid, TextField, Typography } from "@mui/material";
import DatePicker, { DateObject } from "react-multi-date-picker";
import CustomDateInput from "../../../Components/CustomDateInput";
import { useContext, useEffect, useState } from "react";
import * as yup from 'yup';
import brokerGroupApi from "../../../api/brokerGroupApi";
import moment from "jalali-moment";
import { ContextNotification, severitys } from "../../../App";
import RtlProvider from "../../../Components/RtlProvider";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import { RHFRadioGroup } from "../../../Components/RHFRadioGroup";
import EnumMapper from "../../../EnumMapper";


const ConfirmFlight = ({ row, resetForm }) => {

  const [submitLoading, setSubmitLoading] = useState(false);
  const { setOpen } = useContext(ContextNotification);
  const [offScheduleReason, setOffScheduleReason] = useState([]);
  const [delayAmount, setDelayAmount] = useState(0);
  const [inputFlightHourTypeid, setInputFlightHourTypeid] = useState(null);

  const flightHourTypes = [

    {
      id: "1",
      label: "به موقع"
    },
    {
      id: "2",
      label: "با تاخیر"
    },
    {
      id: "3",
      label: "با تعجیل"
    }
  ]
  const schema = yup.object().shape({

  });
  const { register, handleSubmit, control, formState: { errors }, watch, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      offScheduleReasonid: row.offScheduleReason ? row.offScheduleReason.toString() : null,
      FlightHourTypeId: EnumMapper.FlightTimeMode.Ontime,
      flightDateReal: row.flightDateRealPersian ? row.flightDateRealPersian : row.flightDatePersian ?? "",
      flightHourReal: row.flightTimeReal ? row.flightTimeReal : row.flightTime ?? "",
      description:row.description?row.description:null
    }
  });

  const GetOffScheduleReason = () => {
    brokerGroupApi.GetOffScheduleReasonDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        setOffScheduleReason(arr.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        }));
      })
      .catch((error) => console.log(error));
  }
  useEffect(() => {
    GetOffScheduleReason();
    FillRushDelayAmount(row?.flightDate, row?.flightTime, row?.flightDateReal, row?.flightTimeReal);
  }
    , []);

  useEffect(() => {
    if ((row.flightTimeReal) && (row.flightDateRealPersian)) {
      FillRushDelayAmount(row?.flightDate, row?.flightTime, row?.flightDateReal, row?.flightTimeReal);
    }
  }, [row.flightId]);


  const customization = useSelector((state) => state.customization);

  const onSubmit = (data) => {

    const flightHourTypeId = watch("FlightHourTypeId") ? watch("FlightHourTypeId") : EnumMapper.FlightTimeMode.Ontime;
    let flightdateGregorian = null;
    if (data.flightDateReal) {
      let flightD = new DateObject({
        date: data.flightDateReal,
        calendar: persian,
        locale: persian_fa
      });

      var flightdateStr = flightD.year + '/' + flightD.month.number + '/' + flightD.day;
      flightdateGregorian = moment.from(flightdateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    var offScheduleReason = null;
    var flighthournew = data.flighthour;
    var description=null;

    if(data.description)
      description=data.description

    if ((flightHourTypeId !== EnumMapper.FlightTimeMode.Ontime) && ((data.flightHourReal === "") || (data.flightHourReal === null))) {

      setOpen({ IsEnable: true, Message: JSON.stringify(' ساعت واقعی پرواز را وارد نمائید'), severity: severitys.error });
      return;
    }
    else if ((flightHourTypeId !== EnumMapper.FlightTimeMode.Ontime) && ((data.flightDateReal === "") || (data.flightDateReal === null))) {

      setOpen({ IsEnable: true, Message: JSON.stringify(' تاریخ واقعی پرواز را وارد نمائید'), severity: severitys.error });
      return;
    }
    else {
      flighthournew = data.flightHourReal;
      offScheduleReason = watch("offScheduleReasonid") ? parseInt(watch("offScheduleReasonid").toString()) : null;

      const newdata = {
        "flightId": row.flightId,
        "onTime": (flightHourTypeId === EnumMapper.FlightTimeMode.Ontime) ? true : false,
        "offScheduleReason": offScheduleReason,
        "time": flighthournew,
        "flightDate": flightdateGregorian,
        "description":description

      }

      setSubmitLoading(true);
      brokerGroupApi.ConfirmFlight(newdata).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            setOpen({ IsEnable: true, Message: 'پرواز با موفقیت تایید شد', severity: severitys.success });
            resetForm();
          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });

          }

        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
        }

      }).catch(err => {

        if (err.status === 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { setSubmitLoading(false) });
    }
  }

  const FillRushDelayAmount = (flightDate, flightTime, flightDateReal, flightTimeReal) => {
    const [rhours, rminutes] = flightTimeReal?.split(":").map(Number);
    const [hours, minutes] = flightTime?.split(":").map(Number);
    const frealdate = new Date(flightDateReal);
    frealdate.setHours(rhours, rminutes, 0, 0);
    const fdate = new Date(flightDate);
    fdate.setHours(hours, minutes, 0, 0);

    if (fdate < frealdate) {
      setInputFlightHourTypeid(EnumMapper.FlightTimeMode.WithDelay);
      setValue("FlightHourTypeId", EnumMapper.FlightTimeMode.WithDelay);
      var delayAmount = Math.floor((frealdate.getTime() - fdate.getTime()) / (1000 * 60));
      setDelayAmount(delayAmount);

      setValue("flightHourReal", flightTimeReal ? flightTimeReal : "")
      if (row.offScheduleReason)
        setValue("offScheduleReasonid", row.offScheduleReason.toString());
    }
    else if (fdate > frealdate) {
      setInputFlightHourTypeid(EnumMapper.FlightTimeMode.WithRush);
      setValue("FlightHourTypeId", EnumMapper.FlightTimeMode.WithRush);
      var rushAmount = Math.floor((fdate.getTime() - frealdate.getTime()) / (1000 * 60));
      setDelayAmount(rushAmount);
      setValue("flightHourReal", flightTimeReal ? flightTimeReal : "")
    }
    else {
      setInputFlightHourTypeid(EnumMapper.FlightTimeMode.Ontime);
      setValue("FlightHourTypeId", EnumMapper.FlightTimeMode.Ontime);
      setDelayAmount(0);
      setValue("flightHourReal", flightTime ? flightTime : "")
    }
  }
  const handleFlightHourTypeChange = (id) => {
    if ((inputFlightHourTypeid) && (parseInt(id) === parseInt(inputFlightHourTypeid)))
      FillRushDelayAmount(row?.flightDate, row?.flightTime, row?.flightDateReal, row?.flightTimeReal);
    else {
      setValue("offScheduleReasonid", null);
      setDelayAmount(0);
      setValue("flightHourReal", row.flightTime ? row.flightTime : "")

    }
  }
  const onChangeFlightTimeReal = (value) => {
    let flightD = new DateObject({
      date: watch("flightDateReal") ? watch("flightDateReal") : row.flightDateRealPersian,
      calendar: persian,
      locale: persian_fa
    });
    var flightdateStr = flightD.year + '/' + flightD.month.number + '/' + flightD.day;
    var flightdateGregorian = moment.from(flightdateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD');
    setValue("flightHourReal", value);
    FillRushDelayAmount(row?.flightDate, row?.flightTime, flightdateGregorian, value);

  }
  const onChangeflightdateReal = (value) => {
    let flightD = new DateObject({
      date: value,
      calendar: persian,
      locale: persian_fa
    });
    var flightdateStr = flightD.year + '/' + flightD.month.number + '/' + flightD.day;
    setValue("flightDateReal", flightdateStr);
    var flightdateGregorian = moment.from(flightdateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD');

    FillRushDelayAmount(row?.flightDate, row?.flightTime, flightdateGregorian, watch("flightHourReal") ? watch("flightHourReal") : row.flightTimeReal);

  }

  return (
    <div>
      <ThemeProvider theme={customtheme(customization)}>
        <RtlProvider>
          <form onSubmit={handleSubmit(onSubmit)}>

            <Grid container spacing={1} >
              <Grid container spacing={1} sx={{ mt: 2, ml: 2 }} >
                <Grid item md={4} xs={12} >
                  <Typography component="h1" variant="h3" sx={{ display: "flex", alignItems: "center", fontSize: '16px', fontFamily: 'BTitr !important',m:1}} >
                    {'تاریخ پرواز' +' :  '+ row.flightDatePersian ?? ''}  </Typography>
                </Grid>

                <Grid item md={5} xs={12}  >
                 <Typography component="h1" variant="h3" sx={{ display: "flex", alignItems: "center", fontSize: '16px', fontFamily: 'BTitr !important',m:1}} >
                    {'ساعت پرواز (طبق برنامه)'+' :  ' + row.flightTime ?? ''}  </Typography>

                </Grid>
              </Grid>

              <Grid item md={12} xs={12} sx={{ ml: 2 }}>
                <RHFRadioGroup
                  control={control}
                  name="FlightHourTypeId"
                  onChange={handleFlightHourTypeChange}
                  options={flightHourTypes}

                />
              </Grid>
              <Grid container spacing={1} md={12} xs={12} sx={{ ml: 1, mt: 1, mb: 1 }}  >
                {
                  (watch("FlightHourTypeId") && (watch("FlightHourTypeId") === EnumMapper.FlightTimeMode.WithDelay)) &&


                  <Grid item md={4} xs={10} >
                    <RHFAutocomplete
                      control={control}
                      options={offScheduleReason}
                      name="offScheduleReasonid"
                      placeholder="علت تاخیر "
                      style={{
                        border: "none",
                        padding: 2
                      }}
                    />
                  </Grid>}
                {((watch("FlightHourTypeId") !== EnumMapper.FlightTimeMode.Ontime)) &&
                  <>

                    <Grid item md={3} xs={12} sx={{ ml: 1 }}>
                      <Controller
                        control={control}
                        name="flightDateReal"
                        rules={{ required: true }}
                        render={({
                          field: { onChange, name, value },
                          fieldState: { invalid, isDirty },
                        }) => (
                          <>
                            <DatePicker
                              value={value || ""}
                              onChange={(date) => {
                                onChangeflightdateReal(date?.isValid ? date : "");

                              }}
                              format={"YYYY/MM/DD"}
                              calendar={persian}
                              locale={persian_fa}
                              calendarPosition="bottom-right"
                              render={<CustomDateInput label={" تاریخ پرواز واقعی"} />}
                            />

                          </>
                        )}
                      />
                    </Grid>
                    <Grid item md={2} xs={5} >
                      <Controller
                        control={control}
                        name="flightHourReal"
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => {
                          const pickerValue =
                            value && typeof value === "string"
                              ? moment(value, "HH:mm").toDate()
                              : value;

                          return (
                            <DatePicker
                              disableDayPicker
                              format="HH:mm"
                              value={pickerValue}
                              onChange={(date) => {
                                if (date?.isValid) {
                                  const formatted = moment(date.toDate()).format("HH:mm");
                                  onChangeFlightTimeReal(formatted);

                                } else {
                                  onChange("");
                                }
                              }}
                              plugins={[<TimePicker hideSeconds />]}
                              render={<CustomDateInput label={"ساعت پرواز واقعی"} />}
                            />
                          );
                        }}
                      />
                    </Grid>
                    <Grid item md={2} xs={5}>
                      <TextField
                        disabled
                        label={(watch("FlightHourTypeId") === EnumMapper.FlightTimeMode.WithDelay) ? 'میزان تاخیر(دقیقه)' : 'میزان تعجیل(دقیقه)'}
                        value={delayAmount}
                      />

                    </Grid>
                  </>
                }
                <Grid item md={8} xs={10}>
              <TextField label=" توضیحات " 
                {...register("description" )}
                fullWidth
                ></TextField>
                </Grid>
              </Grid>
              <Grid container md={12} xs={12} >
                <Grid item md={9} xs={6}></Grid>
                <Grid item md={3} xs={6}>
                  <Button type="submit" sx={{ width: 150, m: 1 }} disabled={submitLoading} variant="contained" color="primary"  >
                    <BeatLoading loading={submitLoading} color={"#e65100"} />تایید و ثبت</Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </RtlProvider>
      </ThemeProvider>
    </div>
  )
}
export default ConfirmFlight